import { InputLabel } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

const LabelInput = (props) => {
  const {
    children,
    required = false,
    sx = { color: '#444', fontWeight: '700', fontSize: '0.875rem' },
    ...otherProps
  } = props
  return (
    <InputLabel className="input-label" sx={{ ...sx }} {...otherProps}>
      {children}
      {required && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
    </InputLabel>
  )
}

LabelInput.propTypes = {
  required: PropTypes.bool,
  children: PropTypes.any,
  sx: PropTypes.any,
}

export default LabelInput
